// extracted by mini-css-extract-plugin
export default {"wrapper":"UserMessage_wrapper__+xKX8","messageContent":"UserMessage_messageContent__AO-ZN"};